import { ResourceCostFieldConfig } from './_hooks/useWorkloadResourceCostChartData';

export const CPU_FIELDS: ResourceCostFieldConfig = {
  onDemandCost: 'cpuCostOnDemand',
  spotCost: 'cpuCostSpot',
  fallbackCost: 'cpuCostSpotFallback',
  onDemandCount: 'cpuCountOnDemand',
  spotCount: 'cpuCountSpot',
  fallbackCount: 'cpuCountSpotFallback',
  isHourly: true,
  hasOfferingBreakdown: true,
};

export const MEMORY_FIELDS: ResourceCostFieldConfig = {
  onDemandCost: 'ramCostOnDemand',
  spotCost: 'ramCostSpot',
  fallbackCost: 'ramCostSpotFallback',
  onDemandCount: 'ramGibOnDemand',
  spotCount: 'ramGibSpot',
  fallbackCount: 'ramGibSpotFallback',
  isHourly: true,
  hasOfferingBreakdown: true,
};

export const GPU_FIELDS: ResourceCostFieldConfig = {
  onDemandCost: 'gpuCostOnDemand',
  spotCost: 'gpuCostSpot',
  fallbackCost: 'gpuCostSpotFallback',
  onDemandCount: 'gpuCountOnDemand',
  spotCount: 'gpuCountSpot',
  fallbackCount: 'gpuCountSpotFallback',
  isHourly: true,
  hasOfferingBreakdown: true,
};

export const STORAGE_FIELDS: ResourceCostFieldConfig = {
  onDemandCost: 'storageCost',
  spotCost: 'storageCost',
  fallbackCost: 'storageCost',
  onDemandCount: 'storageGib',
  spotCount: 'storageGib',
  fallbackCount: 'storageGib',
  isHourly: false,
  hasOfferingBreakdown: false,
};
